export default __webpack_public_path__ + "static/media/boy.ebcaad03.svg";